<!-- Compact -->
<compact-company-layout [projectid]="projectid" [project]="project" [companyid]="companyid"
    [company]="company"></compact-company-layout>